import script from "./digitalman.vue?vue&type=script&lang=ts&setup=true"
export * from "./digitalman.vue?vue&type=script&lang=ts&setup=true"

import "./digitalman.vue?vue&type=style&index=0&id=802c5826&lang=scss&scoped=true"
import "./digitalman.vue?vue&type=style&index=1&id=802c5826&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802c5826"]])

export default __exports__